import { render, staticRenderFns } from "./numericQuestion.vue?vue&type=template&id=83299a54&"
import script from "./numericQuestion.vue?vue&type=script&lang=js&"
export * from "./numericQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83299a54')) {
      api.createRecord('83299a54', component.options)
    } else {
      api.reload('83299a54', component.options)
    }
    module.hot.accept("./numericQuestion.vue?vue&type=template&id=83299a54&", function () {
      api.rerender('83299a54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/testTaker/numericQuestion.vue"
export default component.exports